import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Refrigerated Van", maintenance: 20, repairs: 75, other: 20 },
  { name: "Box Truck", maintenance: 15, repairs: 25, other: 80 },
  { name: "PickUp Truck", maintenance: 60, repairs: 73, other: 79  },
];

const OrdersByVehicles = () => {
  return (
    <ResponsiveContainer width="100%" height={275}>
      <BarChart data={data} barSize={100}>
        <CartesianGrid vertical={false} stroke="#E5E7EB" strokeOpacity={0.7} />
        <XAxis dataKey="name" />
        <YAxis ticks={[0, 25, 50, 75, 100]} tick={{ fontWeight: "700" }} />
        <Tooltip />
        <Bar dataKey="maintenance" fill="#3b82f6" stackId="a" name="Maintenance" />
        <Bar dataKey="repairs" fill="#ef4444" stackId="a" name="Repairs" />
        <Bar dataKey="other" fill="#5DBB63" stackId={"a"} name="Other" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default OrdersByVehicles;
